import { useOnlineVisitPriceWithVat, withOnlineVisitVat } from '@/common/utils/onlineVisitPriceWithVat';
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: iDYgiKJB9Yi7CUB81stQBK
// Component: q3FGMz6XNu9L

import * as React from 'react';

import Head from 'next/head';
import Link, { LinkProps } from 'next/link';
import { useRouter } from 'next/router';

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName,
} from '@plasmicapp/react-web';
import { DataCtxReader as DataCtxReader__, useDataEnv, useGlobalActions } from '@plasmicapp/react-web/lib/host';

import { DataFetcher } from '@plasmicpkgs/plasmic-query';
import Button from '../../Button'; // plasmic-import: wRtWBmTexyYF/component
import { _useGlobalVariants } from './plasmic'; // plasmic-import: iDYgiKJB9Yi7CUB81stQBK/projectModule
import { _useStyleTokens } from './PlasmicStyleTokensProvider'; // plasmic-import: iDYgiKJB9Yi7CUB81stQBK/styleTokensProvider

import '@plasmicapp/react-web/lib/plasmic.css';

import projectcss from './plasmic.module.css'; // plasmic-import: iDYgiKJB9Yi7CUB81stQBK/projectcss
import sty from './PlasmicServices.module.css'; // plasmic-import: q3FGMz6XNu9L/css

import Icon22Icon from './icons/PlasmicIcon__Icon22'; // plasmic-import: -KwzHfv-9ot5/icon
import Icon23Icon from './icons/PlasmicIcon__Icon23'; // plasmic-import: 0nIlGiQv_m-P/icon
import EitaaSvgIcon from './icons/PlasmicIcon__EitaaSvg'; // plasmic-import: WqDEZH1sW0Ay/icon
import WhatsappSvgIcon from './icons/PlasmicIcon__WhatsappSvg'; // plasmic-import: aiEdwD29mrY6/icon
import CheckSvgIcon from './icons/PlasmicIcon__CheckSvg'; // plasmic-import: Zop7nqClMso8/icon
import Icon6Icon from './icons/PlasmicIcon__Icon6'; // plasmic-import: UYWDQf69XzlE/icon
import Icon24Icon from './icons/PlasmicIcon__Icon24'; // plasmic-import: bFoMwbPekE8y/icon
import { Toman, TomanPrice } from '@/common/components/atom/toman/toman';

createPlasmicElementProxy;

export type PlasmicServices__VariantMembers = {
  type: 'onlineVisit';
};
export type PlasmicServices__VariantsArgs = {
  type?: SingleChoiceArg<'onlineVisit'>;
};
type VariantPropType = keyof PlasmicServices__VariantsArgs;
export const PlasmicServices__VariantProps = new Array<VariantPropType>('type');

export type PlasmicServices__ArgsType = {
  information?: any;
  service?: any;
  onlineVisit?: any;
  waitingTimeInfo?: any;
  expertises?: any;
  seo?: any;
  onEvent?: () => void;
  onlineVisitButtonsToFactorDestinationB?: any;
  /** Optional: replaces the online-visit price in the header (corporate coverage). */
  priceSlot?: React.ReactNode;
};
type ArgPropType = keyof PlasmicServices__ArgsType;
export const PlasmicServices__ArgProps = new Array<ArgPropType>(
  'information',
  'service',
  'onlineVisit',
  'waitingTimeInfo',
  'expertises',
  'seo',
  'onEvent',
  'onlineVisitButtonsToFactorDestinationB',
  'priceSlot',
);

export type PlasmicServices__OverridesType = {
  root?: Flex__<'div'>;
  httpRestApiFetcher?: Flex__<typeof DataFetcher>;
  _15?: Flex__<'div'>;
  _011?: Flex__<'div'>;
  _001?: Flex__<'div'>;
  button?: Flex__<typeof Button>;
};

export interface DefaultServicesProps {
  information?: any;
  service?: any;
  onlineVisit?: any;
  waitingTimeInfo?: any;
  expertises?: any;
  seo?: any;
  onEvent?: () => void;
  onlineVisitButtonsToFactorDestinationB?: any;
  /** Optional: replaces the online-visit price in the header (corporate coverage). */
  priceSlot?: React.ReactNode;
  type?: SingleChoiceArg<'onlineVisit'>;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch { }
  return undefined;
}

function PlasmicServices__RenderFunc(props: {
  variants: PlasmicServices__VariantsArgs;
  args: PlasmicServices__ArgsType;
  overrides: PlasmicServices__OverridesType;
  forNode?: string;
}) {
  // A/B: online-visit price shown with the invoice's 3% VAT for half the patients.
  const onlinePriceWithVat = useOnlineVisitPriceWithVat('profile');
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () => Object.assign({}, Object.fromEntries(Object.entries(props.args).filter(([_, v]) => v !== undefined))),
    [props.args],
  );

  const $props = {
    ...args,
    ...variants,
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: 'type',
        type: 'private',
        variableType: 'variant',
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.type,
      },
    ],
    [$props, $ctx, $refs],
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={'root'}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        {
          [sty.roottype_onlineVisit]: hasVariant($state, 'type', 'onlineVisit'),
        },
      )}
      dir={'rtl'}
    >
      <div
        className={classNames(projectcss.all, sty.freeBox___4HQKm, {
          [sty.freeBoxtype_onlineVisit___4HQKm7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
        })}
      >
        <div
          className={classNames(projectcss.all, sty.freeBox___2Q2QS, {
            [sty.freeBoxtype_onlineVisit___2Q2QS7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
          })}
        >
          <PlasmicIcon__
            PlasmicIconType={hasVariant($state, 'type', 'onlineVisit') ? Icon23Icon : Icon22Icon}
            className={classNames(projectcss.all, sty.svg__p66RR, {
              [sty.svgtype_onlineVisit__p66RR7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
            })}
            role={'img'}
          />

          <div
            className={classNames(projectcss.all, projectcss.__wab_text, sty.text__ue5AT, {
              [sty.texttype_onlineVisit__ue5AT7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
            })}
          >
            {hasVariant($state, 'type', 'onlineVisit')
              ? '\u0647\u0645\u06cc\u0646 \u0627\u0644\u0627\u0646 \u0622\u0646\u0644\u0627\u06cc\u0646 \u0648\u06cc\u0632\u06cc\u062a \u0634\u0648\u06cc\u062f'
              : '\u0646\u0648\u0628\u062a \u0627\u06cc\u0646\u062a\u0631\u0646\u062a\u06cc \u0648 \u0645\u0631\u0627\u062c\u0639\u0647 \u062d\u0636\u0648\u0631\u06cc'}
          </div>
        </div>
        <div
          className={classNames(projectcss.all, projectcss.__wab_text, sty.text__uOdnm, {
            [sty.texttype_onlineVisit__uOdnm7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
          })}
        >
          {hasVariant($state, 'type', 'onlineVisit') && ($props as PlasmicServices__ArgsType).priceSlot ? (
            ($props as PlasmicServices__ArgsType).priceSlot
          ) : hasVariant($state, 'type', 'onlineVisit') ? (
            <React.Fragment>
              {(() => {
                try {
                  return <TomanPrice>{(withOnlineVisitVat($props.service.free_price, onlinePriceWithVat) / 10).toLocaleString()}</TomanPrice>;
                } catch (e) {
                  if (e instanceof TypeError || e?.plasmicType === 'PlasmicUndefinedDataError') {
                    return <TomanPrice>-</TomanPrice>;
                  }
                  throw e;
                }
              })()}
            </React.Fragment>
          ) : (
            '130,000 \u062a\u0648\u0645\u0627\u0646'
          )}
        </div>
      </div>
      <div
        className={classNames(projectcss.all, sty.freeBox__xv7Yc, {
          [sty.freeBoxtype_onlineVisit__xv7Yc7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
        })}
      >
        <div
          className={classNames(projectcss.all, sty.freeBox__qgc4H, {
            [sty.freeBoxtype_onlineVisit__qgc4H7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
          })}
        >
          <div
            className={classNames(projectcss.all, sty.freeBox___4HUOp, {
              [sty.freeBoxtype_onlineVisit___4HUOp7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
            })}
          >
            <div
              className={classNames(projectcss.all, projectcss.__wab_text, sty.text__ynPq, {
                [sty.texttype_onlineVisit__ynPq7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
              })}
            >
              {hasVariant($state, 'type', 'onlineVisit')
                ? '\u0648\u06cc\u0632\u06cc\u062a \u0622\u0646\u0644\u0627\u06cc\u0646 \u062f\u0631:'
                : '\u0627\u0645\u06a9\u0627\u0646 \u062f\u0631\u06cc\u0627\u0641\u062a \u0632\u0648\u062f\u062a\u0631\u06cc\u0646 \u0646\u0648\u0628\u062a'}
            </div>
            <div
              className={classNames(projectcss.all, sty.freeBox__vlbHa, {
                [sty.freeBoxtype_onlineVisit__vlbHa7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
              })}
            >
              {$props.onlineVisit.channels.includes('whatsapp') && (
                <div
                  className={classNames(projectcss.all, sty.freeBox__lnM1, {
                    [sty.freeBoxtype_onlineVisit__lnM17QAlK]: hasVariant($state, 'type', 'onlineVisit'),
                  })}
                >
                  <img src="https://hami.paziresh24.com/hami-logo.svg" alt="پیام‌رسان پذیرش۲۴" className="w-6 h-6" />

                  <div
                    className={classNames(projectcss.all, projectcss.__wab_text, sty.text__jNh3G, {
                      [sty.texttype_onlineVisit__jNh3G7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
                    })}
                  >
                    پیام‌رسان پذیرش۲۴
                  </div>
                </div>
              )}
              {(
                hasVariant($state, 'type', 'onlineVisit')
                  ? (() => {
                    try {
                      return !$props.onlineVisit.channels.includes('whatsapp');
                    } catch (e) {
                      if (e instanceof TypeError || e?.plasmicType === 'PlasmicUndefinedDataError') {
                        return true;
                      }
                      throw e;
                    }
                  })()
                  : true
              ) ? (
                <div
                  className={classNames(projectcss.all, sty.freeBox__lnM1, {
                    [sty.freeBoxtype_onlineVisit__lnM17QAlK]: hasVariant($state, 'type', 'onlineVisit'),
                  })}
                >
                  <EitaaSvgIcon
                    className={classNames(projectcss.all, sty.svg__lpwaK, {
                      [sty.svgtype_onlineVisit__lpwaK7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
                    })}
                    role={'img'}
                    aria-label={'ایتا'}
                  />

                  <div
                    className={classNames(projectcss.all, projectcss.__wab_text, sty.text__jNh3G, {
                      [sty.texttype_onlineVisit__jNh3G7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
                    })}
                  >
                    {'\u0627\u06cc\u062a\u0627'}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          {(() => {
            try {
              return $props.onlineVisit.channels.includes('secure_call');
            } catch (e) {
              if (e instanceof TypeError || e?.plasmicType === 'PlasmicUndefinedDataError') {
                return true;
              }
              throw e;
            }
          })() ? (
            <div
              className={classNames(projectcss.all, projectcss.__wab_text, sty.text___595KF, 'text-primary font-bold', {
                [sty.texttype_onlineVisit___595KF7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
              })}
            >
              {
                '\u0627\u0645\u06a9\u0627\u0646 \u0628\u0631\u0642\u0631\u0627\u0631\u06cc \u062a\u0645\u0627\u0633 \u0628\u0627 \u0627\u06cc\u0646 \u067e\u0632\u0634\u06a9 \u0648\u062c\u0648\u062f \u062f\u0627\u0631\u062f.'
              }
            </div>
          ) : null}
          {(
            hasVariant($state, 'type', 'onlineVisit')
              ? (() => {
                try {
                  // When chat-lifecycle days are provided, always show that line (replaces hardcoded 3-day copy).
                  if ($props.service?.chat_lifecycle_auto_close_days != null) {
                    return true;
                  }
                  // While lifecycle is loading, hide the legacy 3-day sentence to avoid a misleading flash.
                  if ($props.service?.chat_lifecycle_loading) {
                    return false;
                  }
                  return $props.expertises.group_expertises[0].id !== 21 && $props.expertises.group_expertises[0].id !== 47;
                } catch (e) {
                  if (e instanceof TypeError || e?.plasmicType === 'PlasmicUndefinedDataError') {
                    return true;
                  }
                  throw e;
                }
              })()
              : false
          ) ? (
            <div
              className={classNames(projectcss.all, projectcss.__wab_text, sty.text___7Hl7X, {
                [sty.texttype_onlineVisit___7Hl7X7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
              })}
            >
              {(() => {
                try {
                  const lifecycleDays = $props.service?.chat_lifecycle_auto_close_days;
                  if (lifecycleDays != null) {
                    return (
                      <React.Fragment>
                        <React.Fragment>{'\u062a\u0627 '}</React.Fragment>
                        <span className={'plasmic_default__all plasmic_default__span'} style={{ fontWeight: 700 }}>
                          {`${lifecycleDays} \u0631\u0648\u0632`}
                        </span>
                        <React.Fragment>
                          {
                            ' \u067e\u0633 \u0627\u0632 \u0648\u06cc\u0632\u06cc\u062a\u060c \u067e\u0632\u0634\u06a9 \u0634\u0645\u0627 \u0631\u0627 \u0647\u0645\u0631\u0627\u0647\u06cc \u062e\u0648\u0627\u0647\u062f \u06a9\u0631\u062f'
                          }
                        </React.Fragment>
                      </React.Fragment>
                    );
                  }
                } catch (e) {
                  if (!(e instanceof TypeError || e?.plasmicType === 'PlasmicUndefinedDataError')) {
                    throw e;
                  }
                }
                return (
                  <React.Fragment>
                    <React.Fragment>{'\u062a\u0627 '}</React.Fragment>
                    <span className={'plasmic_default__all plasmic_default__span'} style={{ fontWeight: 700 }}>
                      {'\u06f3 \u0631\u0648\u0632'}
                    </span>
                    <React.Fragment>
                      {
                        ' \u0645\u06cc\u200c\u062a\u0648\u0627\u0646\u06cc\u062f \u0647\u0631 \u0633\u0648\u0627\u0644\u06cc \u062f\u0627\u0631\u06cc\u062f \u0627\u0632 \u067e\u0632\u0634\u06a9 \u0628\u067e\u0631\u0633\u06cc\u062f'
                      }
                    </React.Fragment>
                  </React.Fragment>
                );
              })()}
            </div>
          ) : null}
          {(
            hasVariant($state, 'type', 'onlineVisit')
              ? (() => {
                try {
                  return $props.expertises.group_expertises[0].id === 21 || $props.expertises.group_expertises[0].id === 47;
                } catch (e) {
                  if (e instanceof TypeError || e?.plasmicType === 'PlasmicUndefinedDataError') {
                    return true;
                  }
                  throw e;
                }
              })()
              : false
          ) ? (
            <div
              className={classNames(projectcss.all, projectcss.__wab_text, sty.text___26Dwi, {
                [sty.texttype_onlineVisit___26Dwi7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
              })}
            >
              <div
                className={projectcss.__wab_expr_html_text}
                dangerouslySetInnerHTML={{
                  __html: (() => {
                    try {
                      return (() => {
                        const [hours, minutes, seconds] = $props.service.duration.split(':');
                        let humanizedDuration = '';
                        if (+hours === 0 && +minutes === 0) {
                          humanizedDuration = `${+seconds} ثانیه`;
                        } else if (+hours === 0) {
                          humanizedDuration = `${+minutes} دقیقه`;
                        } else if (+minutes === 0) {
                          humanizedDuration = `${+hours} ساعت`;
                        } else {
                          humanizedDuration = `${+hours} ساعت و ${+minutes} دقیقه`;
                        }
                        return `مدت زمان گفت‌وگو: <b>${humanizedDuration}</b>`;
                      })();
                    } catch (e) {
                      if (e instanceof TypeError || e?.plasmicType === 'PlasmicUndefinedDataError') {
                        return '';
                      }
                      throw e;
                    }
                  })(),
                }}
              />
            </div>
          ) : null}
          {(
            hasVariant($state, 'type', 'onlineVisit')
              ? (() => {
                try {
                  return !!$props.waitingTimeInfo.find(item => item.center_id === '5532')?.waiting_time_title;
                } catch (e) {
                  if (e instanceof TypeError || e?.plasmicType === 'PlasmicUndefinedDataError') {
                    return true;
                  }
                  throw e;
                }
              })()
              : (() => {
                try {
                  return true;
                } catch (e) {
                  if (e instanceof TypeError || e?.plasmicType === 'PlasmicUndefinedDataError') {
                    return true;
                  }
                  throw e;
                }
              })()
          ) ? (
            <div
              className={classNames(projectcss.all, projectcss.__wab_text, sty.text__dNgG, {
                [sty.texttype_onlineVisit__dNgG7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
              })}
            >
              <div
                className={projectcss.__wab_expr_html_text}
                dangerouslySetInnerHTML={{
                  __html: (() => {
                    try {
                      return `طبق نظر مراجعین قبلی، میانگین زمان انتظار ویزیت: <b>${$props.waitingTimeInfo.find(item => item.center_id === '5532').waiting_time_title
                        }</b>`;
                    } catch (e) {
                      if (e instanceof TypeError || e?.plasmicType === 'PlasmicUndefinedDataError') {
                        return '\u0645\u06cc\u0627\u0646\u06af\u06cc\u0646 \u0632\u0645\u0627\u0646 \u0627\u0646\u062a\u0638\u0627\u0631 \u062a\u0627 \u0648\u06cc\u0632\u06cc\u062a: ';
                      }
                      throw e;
                    }
                  })(),
                }}
              />
            </div>
          ) : null}
        </div>
        <DataFetcher
          data-plasmic-name={'httpRestApiFetcher'}
          data-plasmic-override={overrides.httpRestApiFetcher}
          className={classNames('__wab_instance', sty.httpRestApiFetcher, {
            [sty.httpRestApiFetchertype_onlineVisit]: hasVariant($state, 'type', 'onlineVisit'),
          })}
          dataName={'fetchedData'}
          errorDisplay={null}
          errorName={'fetchError'}
          loadingDisplay={null}
          method={hasVariant($state, 'type', 'onlineVisit') ? 'GET' : 'GET'}
          noLayout={false}
          url={
            hasVariant($state, 'type', 'onlineVisit')
              ? (() => {
                try {
                  return `https://ravi-apis.paziresh24.com/ravi/v1/online-visit-absent-score/doctors/${encodeURIComponent($props.seo.slug)}`;
                } catch (e) {
                  if (e instanceof TypeError || e?.plasmicType === 'PlasmicUndefinedDataError') {
                    return undefined;
                  }
                  throw e;
                }
              })()
              : 'https://api.github.com/users/plasmicapp/repos'
          }
        >
          <DataCtxReader__>
            {$ctx => (
              <React.Fragment>
                {(
                  hasVariant($state, 'type', 'onlineVisit')
                    ? (() => {
                      try {
                        return $ctx.fetchedData.list[0].penalty_score >= 2;
                      } catch (e) {
                        if (e instanceof TypeError || e?.plasmicType === 'PlasmicUndefinedDataError') {
                          return false;
                        }
                        throw e;
                      }
                    })()
                    : true
                ) ? (
                  <div
                    data-plasmic-name={'_15'}
                    data-plasmic-override={overrides._15}
                    className={classNames(projectcss.all, sty._15, {
                      [sty._15type_onlineVisit]: hasVariant($state, 'type', 'onlineVisit'),
                    })}
                  >
                    <div
                      className={classNames(projectcss.all, projectcss.__wab_text, sty.text__pSbQw, {
                        [sty.texttype_onlineVisit__pSbQw7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
                      })}
                    >
                      {hasVariant($state, 'type', 'onlineVisit')
                        ? '\u0637\u0628\u0642 \u06af\u0632\u0627\u0631\u0634 \u0628\u06cc\u0645\u0627\u0631\u0627\u0646\u060c \u0627\u062d\u062a\u0645\u0627\u0644 \u0639\u062f\u0645 \u067e\u0627\u0633\u062e\u06af\u0648\u06cc\u06cc \u062f\u0631\u0645\u0627\u0646\u06af\u0631 \u0648\u062c\u0648\u062f \u062f\u0627\u0631\u062f.'
                        : 'Enter some text'}
                    </div>
                  </div>
                ) : null}
                {(hasVariant($state, 'type', 'onlineVisit') ? false : false) ? (
                  <div
                    data-plasmic-name={'_011'}
                    data-plasmic-override={overrides._011}
                    className={classNames(projectcss.all, sty._011, {
                      [sty._011type_onlineVisit]: hasVariant($state, 'type', 'onlineVisit'),
                    })}
                  >
                    <div
                      className={classNames(projectcss.all, projectcss.__wab_text, sty.text__owqFp, {
                        [sty.texttype_onlineVisit__owqFp7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
                      })}
                    >
                      {hasVariant($state, 'type', 'onlineVisit')
                        ? '\u0637\u0628\u0642 \u06af\u0632\u0627\u0631\u0634 \u0628\u06cc\u0645\u0627\u0631\u0627\u0646\u060c \u0627\u062d\u062a\u0645\u0627\u0644 \u0639\u062f\u0645 \u067e\u0627\u0633\u062e\u06af\u0648\u06cc\u06cc \u062f\u0631\u0645\u0627\u0646\u06af\u0631 \u0648\u062c\u0648\u062f \u062f\u0627\u0631\u062f.'
                        : 'Enter some text'}
                    </div>
                  </div>
                ) : null}
                {(hasVariant($state, 'type', 'onlineVisit') ? false : false) ? (
                  <div
                    data-plasmic-name={'_001'}
                    data-plasmic-override={overrides._001}
                    className={classNames(projectcss.all, sty._001, {
                      [sty._001type_onlineVisit]: hasVariant($state, 'type', 'onlineVisit'),
                    })}
                  >
                    <div
                      className={classNames(projectcss.all, projectcss.__wab_text, sty.text__etniR, {
                        [sty.texttype_onlineVisit__etniR7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
                      })}
                    >
                      {hasVariant($state, 'type', 'onlineVisit')
                        ? '\u0637\u0628\u0642 \u06af\u0632\u0627\u0631\u0634 \u0628\u06cc\u0645\u0627\u0631\u0627\u0646\u060c \u0627\u062d\u062a\u0645\u0627\u0644 \u0639\u062f\u0645 \u067e\u0627\u0633\u062e\u06af\u0648\u06cc\u06cc \u062f\u0631\u0645\u0627\u0646\u06af\u0631 \u0648\u062c\u0648\u062f \u062f\u0627\u0631\u062f.'
                        : 'Enter some text'}
                    </div>
                  </div>
                ) : null}
              </React.Fragment>
            )}
          </DataCtxReader__>
        </DataFetcher>
        <Button
          data-plasmic-name={'button'}
          data-plasmic-override={overrides.button}
          children2={
            hasVariant($state, 'type', 'onlineVisit') && hasVariant(globalVariants, 'screen', 'mobileOnly') ? (
              <React.Fragment>
                {(() => {
                  try {
                    return `شروع ویزیت آنلاین با ${$props.information.display_name}`;
                  } catch (e) {
                    if (e instanceof TypeError || e?.plasmicType === 'PlasmicUndefinedDataError') {
                      return '\u0634\u0631\u0648\u0639 \u0648\u06cc\u0632\u06cc\u062a';
                    }
                    throw e;
                  }
                })()}
              </React.Fragment>
            ) : hasVariant($state, 'type', 'onlineVisit') ? (
              <React.Fragment>
                {(() => {
                  try {
                    return `شروع ویزیت با ${$props.information.display_name}`;
                  } catch (e) {
                    if (e instanceof TypeError || e?.plasmicType === 'PlasmicUndefinedDataError') {
                      return '\u0634\u0631\u0648\u0639 \u0648\u06cc\u0632\u06cc\u062a';
                    }
                    throw e;
                  }
                })()}
              </React.Fragment>
            ) : (
              '\u062f\u0631\u06cc\u0627\u0641\u062a \u0646\u0648\u0628\u062a'
            )
          }
          className={classNames('__wab_instance', sty.button, {
            [sty.buttontype_onlineVisit]: hasVariant($state, 'type', 'onlineVisit'),
          })}
          endIcon={
            <PlasmicIcon__
              PlasmicIconType={hasVariant($state, 'type', 'onlineVisit') ? Icon24Icon : Icon6Icon}
              className={classNames(projectcss.all, sty.svg__nu5Bc, {
                [sty.svgtype_onlineVisit__nu5Bc7QAlK]: hasVariant($state, 'type', 'onlineVisit'),
              })}
              role={'img'}
            />
          }
          onClick={async event => {
            const $steps = {};

            $steps['runOnEvent'] = true
              ? (() => {
                const actionArgs = { eventRef: $props['onEvent'] };
                return (({ eventRef, args }) => {
                  return eventRef?.(...(args ?? []));
                })?.apply(null, [actionArgs]);
              })()
              : undefined;
            if (
              $steps['runOnEvent'] != null &&
              typeof $steps['runOnEvent'] === 'object' &&
              typeof $steps['runOnEvent'].then === 'function'
            ) {
              $steps['runOnEvent'] = await $steps['runOnEvent'];
            }

            $steps['goToFactorV2'] = true
              ? (() => {
                const actionArgs = {
                  destination: (() => {
                    try {
                      return `https://www.paziresh24.com/factor/v2/${$props.seo.slug}/${$props.service.id}/`;
                    } catch (e) {
                      if (e instanceof TypeError || e?.plasmicType === 'PlasmicUndefinedDataError') {
                        return undefined;
                      }
                      throw e;
                    }
                  })(),
                };
                return (({ destination }) => {
                  if (typeof destination === 'string' && destination.startsWith('#')) {
                    document.getElementById(destination.substr(1)).scrollIntoView({ behavior: 'smooth' });
                  } else {
                    __nextRouter?.push(destination);
                  }
                })?.apply(null, [actionArgs]);
              })()
              : undefined;
            if (
              $steps['goToFactorV2'] != null &&
              typeof $steps['goToFactorV2'] === 'object' &&
              typeof $steps['goToFactorV2'].then === 'function'
            ) {
              $steps['goToFactorV2'] = await $steps['goToFactorV2'];
            }

            $steps['sendEvent'] = true
              ? (() => {
                const actionArgs = {
                  customFunction: async () => {
                    return (() => {
                      try {
                        return window.paziresh24?.logger('doctor-profile').sendEvent({
                          group: 'doctor profile',
                          type: 'doctor profile press online visit book button',
                          event: {
                            page_url: window.location.pathname,
                            referrer: window.document.referrer,
                            group_expertises: $props.expertises.group_expertises[0]?.name ?? 'سایر',
                            doctor_name: $props.information.display_name,
                          },
                        });
                      } catch (error) {
                        return console.log(error);
                      }
                    })();
                  },
                };
                return (({ customFunction }) => {
                  return customFunction();
                })?.apply(null, [actionArgs]);
              })()
              : undefined;
            if ($steps['sendEvent'] != null && typeof $steps['sendEvent'] === 'object' && typeof $steps['sendEvent'].then === 'function') {
              $steps['sendEvent'] = await $steps['sendEvent'];
            }
          }}
          showEndIcon={hasVariant($state, 'type', 'onlineVisit') ? true : undefined}
          space={hasVariant($state, 'type', 'onlineVisit') ? true : undefined}
        />
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ['root', 'httpRestApiFetcher', '_15', '_011', '_001', 'button'],
  httpRestApiFetcher: ['httpRestApiFetcher', '_15', '_011', '_001'],
  _15: ['_15'],
  _011: ['_011'],
  _001: ['_001'],
  button: ['button'],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> = typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: 'div';
  httpRestApiFetcher: typeof DataFetcher;
  _15: 'div';
  _011: 'div';
  _001: 'div';
  button: typeof Button;
};

type ReservedPropsType = 'variants' | 'args' | 'overrides';
type NodeOverridesType<T extends NodeNameType> = Pick<PlasmicServices__OverridesType, DescendantsType<T>>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicServices__VariantsArgs;
    args?: PlasmicServices__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicServices__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
  // Specify args directly as props
  Omit<PlasmicServices__ArgsType, ReservedPropsType> &
  // Specify overrides for each element directly as props
  Omit<NodeOverridesType<T>, ReservedPropsType | VariantPropType | ArgPropType> &
  // Specify props for the root element
  Omit<Partial<React.ComponentProps<NodeDefaultElementType[T]>>, ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>>;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(props: T & StrictProps<T, PropsType>) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicServices__ArgProps,
          internalVariantPropNames: PlasmicServices__VariantProps,
        }),
      [props, nodeName],
    );
    return PlasmicServices__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === 'root') {
    func.displayName = 'PlasmicServices';
  } else {
    func.displayName = `PlasmicServices.${nodeName}`;
  }
  return func;
}

export const PlasmicServices = Object.assign(
  // Top-level PlasmicServices renders the root element
  makeNodeComponent('root'),
  {
    // Helper components rendering sub-elements
    httpRestApiFetcher: makeNodeComponent('httpRestApiFetcher'),
    _15: makeNodeComponent('_15'),
    _011: makeNodeComponent('_011'),
    _001: makeNodeComponent('_001'),
    button: makeNodeComponent('button'),

    // Metadata about props expected for PlasmicServices
    internalVariantProps: PlasmicServices__VariantProps,
    internalArgProps: PlasmicServices__ArgProps,
  },
);

export default PlasmicServices;
/* prettier-ignore-end */
